import { useFormik } from 'formik';
import * as yup from 'yup';
import { useLoginMutation } from './login.api';
import { useAppDispatch } from '../../app/hooks';
import { setToken } from './authSlice';
import styles from './login.module.css';
import { Card, CardContent } from 'shared-components';
import { Button } from 'shared-components';
import { FormGroup } from 'shared-components';
import { Link } from 'react-router-dom';
import { FormLayout } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';
import { EnvelopeIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { Logo } from 'shared-components';
import classNames from 'classnames';

export const Login = () => {
  const dispatch = useAppDispatch();
  const [
    login, // This is the mutation trigger
  ] = useLoginMutation();

  const { handleSubmit, getFieldProps } = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: yup.object({
      email: yup.string().required().email(),
      password: yup.string().required(),
    }),
    onSubmit: async (values) => {
      const result = await login(values);
      if ('error' in result) {
        console.error(result.error);
      } else if ('data' in result) {
        //localStorage.setItem('auth_token', result.data.token);
        dispatch(setToken(result.data.token));
      }
    },
  });
  return (
    <div className={styles.container}>
      <Logo />
      <Card className={styles.card}>
        <CardContent standalone={true}>
          <h2 className={styles.title}>Login</h2>
          <form className={styles.form} onSubmit={handleSubmit}>
            <FormLayout>
              <FormGroup>
                <Label htmlFor="email">Email</Label>
                <Input
                  withIcon={<EnvelopeIcon height={22} width={22} />}
                  bigger={true}
                  placeholder="Enter your email"
                  type="email"
                  id="email"
                  {...getFieldProps('email')}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="password">Password</Label>
                <Input
                  withIcon={<LockClosedIcon height={22} width={22} />}
                  placeholder="6+ Characters, 1 Capital letter"
                  bigger={true}
                  type="password"
                  id="password"
                  {...getFieldProps('password')}
                />
              </FormGroup>
              <FormGroup>
                <Button
                  className={classNames('w-100', styles.button)}
                  bigger={true}
                  type="submit"
                >
                  Login
                </Button>
              </FormGroup>
              <FormGroup>
                <Link to="/forgotten">Forgotten your password?</Link>
              </FormGroup>
            </FormLayout>
            <p
              style={{
                marginTop: '1.5rem',
                textAlign: 'center',
              }}
            >
              Don't have an account yet?{' '}
              <Link to="/register">Register now</Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
